module.exports = new __parcel__URL__("displayErrorIcon.3bd706b2.svg").toString();